import { status } from 'skin/event/status';
import { message } from 'skin/event';
import user from 'skin/store/user';

const setInput = (obj, form, story, data, d, action) => {
	const partnerId = data.s.values.fld.partnerId
	if(partnerId && user.code === 'grilan' && !obj.name === 'txtcode') {
		message(`Редактирование партнерского товара не активно`, 'Продукты');
		return status.ignore
	}
};

export default setInput;
